module.exports = __webpack_public_path__ + "static/media/logo.5cd3b728.svg";